<template>
    <section>
        <b-row class="grid-header" v-if="!hideAction">
            <b-col cols="12">
            <div class="pull-right mb-1">
                <b-button size="sm" variant="primary"
                :disabled="checkedRowItemIds.length == 0"
                @click="onRelease()">
                    Release
                </b-button>
            </div>
            </b-col>
        </b-row>
        <grid-component
            isResizable
            :gridId="inventoryAllocatedGridId"
            :canEdit="checkClaim(CAN_EDIT_INVENTORY)"
            :canDelete="checkClaim(CAN_DELETE_INVENTORY)"
            :itemData="itemData"
            :fields="fields"
            :styleCustom="'height: 160px'"
        />
<!--      :navigationField="'partNumber'"-->
<!--      @checkedItem="checkedRowItemIds=$event"-->
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from './fields';
import { GRID_ID } from '@/shared/constants';

export default {
    components: {
        GridComponent
    },
    props: {
        partId: {
            type: [Number, String],
            default: 0
        },
        hideAction: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            fields,
            checkedRowItemIds: [],
            inventoryAllocatedGridId: GRID_ID.INVENTORY_SALES_ORDERS_ALLOCATED_GRID,
            allocationsList:[],
        }
    },
    computed: {
        ...mapGetters('inventory', ['allocatedParts']),
        itemData() {
             return this.allocatedParts.map(allocation => ({
                ...allocation
            }));
        },
        // allocationsSelected() {
        //     return this.allocationsList.filter(allocated => this.checkedRowItemIds.includes(allocated.id));
        // }
    },
    methods: {
        ...mapActions('inventory', ['getAllocationsByPartId',
          // 'releaseAllocated'
        ]),
        async getData() {
            if(this.partId){
              this.allocationsList = await this.getAllocationsByPartId(this.partId);
            }
        },
        /*async onRelease() {
            await this.releaseAllocated({
                partId: this.partId,
                allocations: this.allocationsSelected
            });
            this.$snotify.success('Successfully Released Selected Inventories');
            this.$emit('refreshAvailableParts');
        }*/
    },
    watch: {
        partId() {
          if(!this.partId) {this.allocationsList = []}
          this.getData();
          },
       // inventoryId() { this.getData(); }
    },
    mounted() {
        if (this.partId) { this.getData(); }
    }
}
</script>
